/**
 * Procedure-note thread API (Phase 4.0i).
 *
 * Three endpoints — write a note, read a sitting's thread, and aggregate
 * every procedure note bound to a visit. The visit-axis aggregation is
 * what the visit-page Notes section uses to merge procedure notes with
 * generic visit-level NOTE metadata in one shot.
 */
import apiClient from './apiClient';

function handleResult(response) {
  return { success: true, data: response.data };
}

function handleError(error, fallback) {
  const detail =
    error?.response?.data?.detail
    || error?.response?.data?.message
    || error?.message
    || fallback;
  return { success: false, error: detail };
}

/**
 * POST /api/organisation/plans/{plan_id}/sittings/{sitting_id}/notes
 * @param {string} planId
 * @param {string} sittingId
 * @param {object} body { body: string (1..4000) }
 * @returns ProcedureNoteResponse
 */
export const addProcedureNote = async (planId, sittingId, body) => {
  try {
    const r = await apiClient.post(
      `/api/organisation/plans/${planId}/sittings/${sittingId}/notes`,
      body,
    );
    return handleResult(r);
  } catch (err) {
    return handleError(err, 'Failed to post note.');
  }
};

/** GET /api/organisation/plans/{plan_id}/sittings/{sitting_id}/notes */
export const listSittingNotes = async (planId, sittingId) => {
  try {
    const r = await apiClient.get(
      `/api/organisation/plans/${planId}/sittings/${sittingId}/notes`,
    );
    return handleResult(r);
  } catch (err) {
    return handleError(err, 'Failed to load notes.');
  }
};

/** GET /api/organisation/visits/{visit_id}/notes */
export const listVisitNotes = async (visitId) => {
  try {
    const r = await apiClient.get(
      `/api/organisation/visits/${visitId}/notes`,
    );
    return handleResult(r);
  } catch (err) {
    return handleError(err, 'Failed to load procedure notes for visit.');
  }
};

const procedureNoteApi = {
  addProcedureNote,
  listSittingNotes,
  listVisitNotes,
};

export default procedureNoteApi;
